export default __webpack_public_path__ + "static/media/arrow-bottom.2702269b.svg";